import axiosInstance from "../axiosInstance";
import { endpoints } from "../endpoints";

export const createNote = async (body) => {
  //   console.warn("update video", body, endpoints.video.update);
  const res = await axiosInstance.post(endpoints.note.create, body);
  return res.data;
};
export const deleteNote = async (id) => {
  //   console.warn("update video", body, endpoints.video.update);
  const res = await axiosInstance.post(`${endpoints.note.delete}/${id}/delete`);
  return res.data;
};
export const getNote = async (id) => {
  //   console.warn("update video", body, endpoints.video.update);
  const res = await axiosInstance.get(endpoints.note.get + id);
  return res.data.data;
};
